import { dialog } from "../../../../nq-component";
import React, { useState } from "react";

function DialogRemarks({ confirm, onchange, oncontinue }) {
  const [remarks, setRemarks] = useState("");
  console.log(remarks);
  return (
    <>
      <div className="p-4">
        <div className="d-flex flex-column align-items-center gap-3">
          <div className="align-self-start align-items-center d-flex gap-2">
            <i
              class="bi bi-chat-square-text fs-2 px-2 rounded"
              style={{ backgroundColor: "#F5F5F5", color: "#D18237" }}
            ></i>
            <h5 className="fw-bold" style={{ color: "#D18237" }}>
              Remarks
            </h5>
          </div>
          <div className="d-flex flex-column mt-2 w-100 px-4">
            <div className="ms-2 me-1">
              <textarea
                className="w-100 rounded-1 p-2"
                placeholder="Enter remarks here..."
                style={{
                  fontSize: "0.9rem",
                  maxHeight: "170px",
                  minHeight: "100px",
                }}
                // rows="3"
                onChange={(e) => {
                  onchange(e);
                  setRemarks(e.target.value);
                }}
                onInput={(e) => {
                  e.target.style.height = "auto";
                  e.target.style.height = `${Math.min(
                    e.target.scrollHeight,
                    150
                  )}px`;
                }}
              ></textarea>
            </div>
          </div>
        </div>
      </div>
      <div className="text-center mb-3">
        <>
          <>
            <button
              className="btn"
              style={{ backgroundColor: "#e8ecf3" }}
              onClick={() => dialog.close()}
            >
              Cancel
            </button>
            <button
              className="btn text-white ms-2"
              style={{
                backgroundColor: remarks === "" ? "#d1823775" : "#D18237",
              }}
              onClick={oncontinue}
              disabled={remarks === ""}
            >
              Continue
            </button>
          </>
        </>
      </div>
    </>
  );
}

export default DialogRemarks;
